import { Container } from '@mui/system';
import React , { useState , useEffect } from 'react'
import { Chart } from "react-google-charts";

 
  export const options = {
    chart: {
      title: "Registro de comercios e Inscripciones",
      subtitle: "ultimos 30 días",
    },
  };

function Grafico() {
    const [data,setData] = useState([]);
    const getGrafico = () => {

        const baseURL = process.env.REACT_APP_SERVER_PATH+'grafico';
        fetch(`${baseURL}`)
         .then(res => res.json())
        .then(
          (result) => {
          setData(result);
          },
          (error) => {
          }
        )
       }
       useEffect(() => {
        getGrafico(); 
    },[])
  return (
    <Container component="main" maxWidth="xl" sx={{mt: 4}}>
    <Chart
    chartType="Bar"
    width="100%"
    height="500px"
    data={data}
    options={options}
  />
  </Container>
  )
}

export default Grafico